module.exports = "https://sf6-scmcdn2-tos.pstatp.com/motor/pc/_next/static/images/score-bg-4064bbedc64a292a4cf073a8be22a52b.png";